import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { OAuthApplication } from "@/services/auth";

interface IProps {
  objData: fhir5.PaymentNotice | undefined;
}

export async function PostPaymentNotice(objData: IProps) {
  const url = `${endpoints.ADMFHIR}/PaymentNotice`;

  const data = JSON.stringify(objData);
  const headers = {
    Accept: "*/*",
    Authorization: (await useAuth.getUserToken()) || (await OAuthApplication()),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Created) {
        throw new Error(`PostPaymentNotice: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("PostPaymentNotice", error);
      // toast.error(`PostPaymentNotice Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
